import { academiesLocalePt } from '../sections/Academies/i18n';
import { bundlesLocalePt } from '../sections/Bundles/i18n';
import { careersLocalePt } from '../sections/Careers/i18n';
import { coursesLocalePt } from '../sections/Courses/i18n';
import { degreesLocalePt } from '../sections/Degrees/i18n';
import { tracksLocalePt } from '../sections/Tracks/i18n';

const localePt = {
  pt: {
    ...academiesLocalePt,
    ...bundlesLocalePt,
    ...careersLocalePt,
    ...coursesLocalePt,
    ...degreesLocalePt,
    ...tracksLocalePt,
  },
};

export default localePt;
